//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('activityTypeActStatuses', {
//        templateUrl: 'views/components/views/activityTypeActStatuses/activityTypeActStatuses.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'utilityService', 'activityTypeActStatusesService', function ($stateParams, stateService, utilityService, activityTypeActStatusesService) {
//            const vm = this;
//            let argType = $stateParams.argtype;
//            let argValue = $stateParams.argvalue;

//			vm.model = {
//				setting: {},
//				itemsListStatuses: []
//			};

//            async function loadSetting() {
//                vm.model.setting = (await activityTypeActStatusesService.getSetting({
//                    argtype: argType,
//                    argvalue: argValue
//                }))[0];

//                return loadStatuses();
//            }

//            async function loadStatuses() {
//				if (utilityService.validateParmsValue(vm.model.setting.argtype) !== true) return;
//				if (utilityService.validateParmsValue(vm.model.setting.argvalue) !== true) return;

//                return vm.model.itemsListStatuses = await activityTypeActStatusesService.listStatuses({
//                    argtype: vm.model.setting.argtype,
//                    argvalue: vm.model.setting.argvalue
//                });
//            }

//            vm.goToFunc = function (state, e) {
//                function go(parms) {
//                    if (e?.ctrlKey) {
//                        stateService.newTab(state, parms);
//                    } else {
//                        stateService.go(state, parms);
//                    }
//                }

//                switch (state) {
//                    case 'actstatus':
//                        go({ actstatus_keyno: '0' });
//                        break;
//                    default:
//                        break;
//                }
//            };

//            vm.$onInit = function () {
//                loadSetting();
//            }
//        }]
//    });
//})();
